import React, { FunctionComponent } from "react";

import { getPrettyNumber } from "../../../Common";
import { IGPSData } from "../../../../Models/Models";
import {
    DigitalShareTable,
    DigitalShareTableRow,
    DigitalShareTableHeader,
    DigitalShareTableData
} from "./GPSVolumeMetricsStyled";

interface IGPSVolumeMetricsOutputProps {
    storeData: IGPSData;
    benchmarkData?: IGPSData;
}

const getGPSVolumeMetricsOutputTableRows = (
    rowText: string,
    visitorCount: number,
    visitCount: number,
): JSX.Element => {
    return (
        <DigitalShareTableRow>
            <DigitalShareTableData isDifferent>{rowText}</DigitalShareTableData>
            <DigitalShareTableData>{getPrettyNumber(visitorCount, 0)}</DigitalShareTableData>
            <DigitalShareTableData>{getPrettyNumber(visitCount, 0)}</DigitalShareTableData>
            <DigitalShareTableData>{getPrettyNumber(visitCount / visitorCount, 2)}</DigitalShareTableData>
        </DigitalShareTableRow>
    );
};

export const GPSVolumeMetricsOutput: FunctionComponent<IGPSVolumeMetricsOutputProps> = (
    props: IGPSVolumeMetricsOutputProps,
) => {
    const {
        storeData,
        benchmarkData,
    } = props;

    return (
        <DigitalShareTable>
            <thead>
                <DigitalShareTableRow>
                    <DigitalShareTableHeader></DigitalShareTableHeader>
                    <DigitalShareTableHeader>Number of visitors</DigitalShareTableHeader>
                    <DigitalShareTableHeader>Number of visits</DigitalShareTableHeader>
                    <DigitalShareTableHeader>Visits per visitor</DigitalShareTableHeader>
                </DigitalShareTableRow>
            </thead>
            <tbody>
                {getGPSVolumeMetricsOutputTableRows(
                    "Your Selection",
                    storeData.mapData.length,
                    storeData.visitsCount,
                )}
                {/* Benchmark Data */}
                {benchmarkData && getGPSVolumeMetricsOutputTableRows(
                    "Your Benchmark",
                    benchmarkData.mapData.length,
                    benchmarkData.visitsCount,
                )}
            </tbody>
        </DigitalShareTable>
    );
};